import { Box, IconButton, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

interface ActivityTimerProps {
  elapsedSeconds: number;
  isActive: boolean;
  onToggle?: () => void;
  showControls?: boolean;
}

const formatTime = (seconds: number): string => {
  const dur = dayjs.duration(seconds, "seconds");
  const hours = Math.floor(dur.asHours());

  if (hours > 0) {
    return `${hours}:${dur.format("mm:ss")}`;
  }
  return dur.format("mm:ss");
};

export const ActivityTimer = ({
  elapsedSeconds,
  isActive,
  onToggle,
  showControls = false,
}: ActivityTimerProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 2,
        py: 1,
        backgroundColor: isActive ? "primary.main" : "grey.700",
        boxShadow: isActive
          ? "none"
          : (theme) => `0 0 0 3px ${theme.palette.warning.main}`,
        color: "white",
        borderRadius: 1,
        transition: "background-color 0.3s, box-shadow 0.3s",
      }}
    >
      {isActive ? (
        <AccessTimeIcon sx={{ fontSize: 20 }} />
      ) : (
        <PauseIcon sx={{ fontSize: 20 }} />
      )}
      <Typography variant="body2Mono">{formatTime(elapsedSeconds)}</Typography>
      {showControls && onToggle ? (
        <IconButton
          size="small"
          onClick={onToggle}
          sx={{
            color: "white",
            ml: 0.5,
            p: 0.5,
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
        >
          {isActive ? (
            <PauseIcon sx={{ fontSize: 18 }} />
          ) : (
            <PlayArrowIcon sx={{ fontSize: 18 }} />
          )}
        </IconButton>
      ) : null}
    </Box>
  );
};
